<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AWft6l/tc-custom/9780544201200.jpg?1700880628377" alt="This image is the cover for the book Passager, The Young Merlin Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Passager, The Young Merlin Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The legendary wizard’s early years are explored in this magical adventure by the acclaimed author of the Pit Dragon Chronicles. </b><br/><br/>A boy is abandoned in the woods of medieval England. A year passes—a year of terror and hunger, of sleeping in trees and foraging for food, of outrunning packs of wild dogs—until one day a falconer captures and tames the boy as he would any passager, a young bird caught in the wild and trained. The falconer adopts the boy and teaches him all of the things he’s forgotten, including the boy’s true name—and the legacy of magic that will be his when he comes of age. <br/><br/><a id="_Hlk71220110"></a><b>Praise for <i>Passager</i></b><br/><br/><b>“This first book of the Young Merlin Trilogy will have readers awaiting the sequels.” —<i>The Horn Book</i></b><br/><br/><b>“Steeped in hawks, mews, and wood life, the trilogy evokes a romantic, dreamy time. But its unadorned language lets the story emerge in a guileless way that will captivate young readers. This is a fine read-aloud.” —<i>San Diego Union Tribune</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Yolen
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;&amp;lt;strong&amp;gt;Jane Yolen&amp;lt;/strong&amp;gt; is a highly acclaimed author who has written hundreds of books for children and adults and has won numerous awards. She and her husband divide their time between Massachussetts and Scotland.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5375eda0